import { render, staticRenderFns } from "./Brochure.vue?vue&type=template&id=70d13562&scoped=true"
import script from "./Brochure.vue?vue&type=script&lang=js"
export * from "./Brochure.vue?vue&type=script&lang=js"
import style0 from "./Brochure.vue?vue&type=style&index=0&id=70d13562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d13562",
  null
  
)

export default component.exports